<template>
    <f7-panel left reveal theme-dark>
        <f7-view>
            <f7-page>
                <f7-list media-list>
                    <f7-list-item v-bind:title="fullname" v-bind:subtitle="email" >
                        <avatar v-bind:username="fullname" slot="media" width="80" v-if="! avatar"></avatar>
                        <img slot="media" v-bind:src="avatar" width="60" v-if="avatar" />
                    </f7-list-item>
                </f7-list>

                <f7-list accordion-item>
                    <f7-list-item v-for="(route, index) in routes" :key="index" @click="changeRoute(route.name)" :title="$ml.get(route.title)" v-show="checkPermission(route.permission)">
                        <i class="f7-icons" slot="media">{{ route.icon }}</i>
                    </f7-list-item>

                    <f7-list-item accordion-item :title="$ml.get('language')">
                        <i class="f7-icons" slot="media">world</i>
                        <f7-accordion-content>
                            <f7-list>
                                <f7-list-item v-for="lang in $ml.list" :key="lang" @click="changeLang(lang)" :title="lang"><i class="f7-icons" slot="media"></i></f7-list-item>
                            </f7-list>
                        </f7-accordion-content>
                    </f7-list-item>
                </f7-list>

                <f7-list>
                    <f7-list-item @click="signOut" :title="$ml.get('signOut')">
                        <i class="f7-icons" slot="media">exit_round</i>
                    </f7-list-item>
                </f7-list>
            </f7-page>
        </f7-view>
    </f7-panel>
</template>
<script>
    import Avatar  from 'vue-avatar'
    import routers from '../router'

    export default {
        components: {
            Avatar
        },
        data() {
            return {
                fullname: '',
                email:    '',
                avatar:   '',
                routes:   [],
                permissions: [],
            }
        },
        methods: {
            changeRoute(route) {
                this.$f7 && this.$f7.panel.close()
                return this.$router.push({name: route})
            },
            signOut() {
                this.$f7 && this.$f7.panel.close()
                localStorage.removeItem('userLogin')
                localStorage.removeItem('permission')

                return this.$router.push({name: 'Login'})
            },
            changeLang(lang) {
                this.$ml.change(lang)
                this.$f7 && this.$f7.panel.close()
            },
            getProfile() {
                if (localStorage.userLogin) {
                    let userLogin = JSON.parse(localStorage.userLogin)
                    this.fullname = `${userLogin.first_name} ${userLogin.last_name}`
                    this.email    = userLogin.email
                    this.avatar   = userLogin.avatar
                }
                if (localStorage.permission) {
                    this.permissions = JSON.parse(localStorage.permission)
                }
            },
            checkPermission(permission) {
                if (! permission) return true

                return this.permissions[permission]
            },
        },
        async created() {
            this.routes = routers.filter(( obj ) => obj.showInMenu === true)
            this.getProfile()
            this.$listener.$on('reloadData', () => this.getProfile())
        },
    };
</script>